import { ForemanJobService } from './foreman-job.service';

export function formatWorkOrderLabel(
  phaseName?: string | null,
  description?: string | null
): string {
  const label = (phaseName || '').trim();
  const detail = (description || '').trim();
  if (label && detail) {
    return `${label} - ${detail}`;
  }
  return label || detail;
}

export interface WorkOrderDisplayData {
  foremanPhaseID?: string | null;
  foremanPhaseIDs?: Array<string | null | undefined> | null;
  foremanPhaseName?: string | null;
  foremanPhaseNames?: Array<string | null | undefined> | null;
}

export function getWorkOrderDisplayName(
  foremanJobService: ForemanJobService,
  foremanPhaseID?: string | null,
  phaseName?: string | null
) {
  return foremanJobService.formatWorkOrderLabelById(foremanPhaseID, phaseName);
}

export function getSingleWorkOrderDisplayName(
  foremanJobService: ForemanJobService,
  item?: WorkOrderDisplayData | null,
  fallback = 'WO Not Set'
) {
  return (
    getWorkOrderDisplayName(
      foremanJobService,
      item?.foremanPhaseID || item?.foremanPhaseIDs?.[0],
      item?.foremanPhaseName || item?.foremanPhaseNames?.[0]
    ) || fallback
  );
}
